import CasePreviewContainer from './CasePreviewContainer';

export default CasePreviewContainer;
